import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isGtmEnabled, trackEvent } from '../../utils/analytics';

export default function GtmPageView() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (!isGtmEnabled()) return;
        trackEvent('page_view', {
            page_path: `${pathname}${search}`,
            page_title: document.title
        });
    }, [pathname, search]);

    return null;
}
